import i18n from '@/utils/i18n';
import { Loading } from 'element-ui'

export function openLoading() {
  Loading.service({
    fullscreen: true,
    text: i18n.t("common.hardLoading"),
    spinner: 'el-icon-loading'
  })
}
export function closeLoading() {
  Loading.service().close()
}
